module.exports = __webpack_public_path__ + "img/svg/language.c8ef59abafa6bdde10e47c7d51cc9226.svg";